export default __webpack_public_path__ + "static/media/closeSideModel.ed06df86.svg";